// extracted by mini-css-extract-plugin
export default {"catalogByService":"c-h_fg"};